<template>
  <div @drop="(event) => dragToSubmitCmp(event, componentIndex)"
       @dragover="allowSignalMeasureDrop"
       :style="`${'height: 100%; background-color: '+backgroundColor}`">
    <div @click="(event)=>clickSelect(event)"
         @dblclick="dbClickSetting"
         v-if="horizontal">
      <el-container style="margin-right: 10px">
        <el-aside width="70px" style="padding: 10px 0px 0px 4px;overflow: hidden">
          <el-tooltip :content="uDataSources.text" placement="top-start" :open-delay="1000">
          <p :style="`${'cursor: default;font-size: '+fontSize +'px;color: '+fontColor}`"
                @dblclick="(event)=>dbClick(event,name)" v-show="!edit">{{uDataSources.text}}</p>
          </el-tooltip>
          <el-input v-show="edit" v-model="uDataSources.text" size="mini" @keyup.enter.native="saveControlName">
          </el-input>
        </el-aside>
        <el-main style="padding: 0px 20px 0px 10px">
          <a>
            <el-slider :max="max" :min="min" v-model="num" style="margin: 0px"></el-slider>
          </a>
        </el-main>
      </el-container>
      <div class="cmp-handle" style="z-index:999">
        <el-dropdown>
        <span class="el-dropdown-link">
          <i class="el-input__icon el-icon-more"></i>
        </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="settingVisible=true"
                              style="text-align: center">设置
            </el-dropdown-item>
            <el-dropdown-item @click.native="editSignalName"
                              style="text-align: center">重命名
            </el-dropdown-item>
            <el-dropdown-item @click.native="select()"
                              style="text-align: center">{{selcted ? '取消选中' : '选中'}}
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleCmp('delete',componentIndex)"
                              style="text-align: center">删除
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div @click="(event)=>clickSelect(event)"
         @dblclick="dbClickSetting"
         v-else>
      <a>
        <el-slider
            v-model="num"
            :max="max"
            :min="min"
            vertical
            style="margin: 29px 0px 8px 0px"
            :height="sliderHeight">
        </el-slider>
      </a>
      <el-tooltip :content="uDataSources.text" placement="top-start" :open-delay="1000">
        <p @dblclick="(event)=>dbClick(event,name)" v-show="!edit"
           :style="`${'display: block;cursor: default;font-size: '+fontSize +'px;color: '+fontColor}`">{{uDataSources.text}}</p>
      </el-tooltip>
      <el-input v-show="edit" v-model="uDataSources.text" size="mini" @keyup.enter.native="saveControlName">
      </el-input>
      <div class="cmp-handle-vertical" style="z-index:999">
        <el-dropdown>
        <span class="el-dropdown-link">
          <i class="el-input__icon el-icon-more"></i>
        </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="settingVisible=true"
                              style="text-align: center">设置
            </el-dropdown-item>
            <el-dropdown-item @click.native="editSignalName"
                              style="text-align: center">重命名
            </el-dropdown-item>
            <el-dropdown-item @click.native="select()"
                              style="text-align: center">{{selcted ? '取消选中' : '选中'}}
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleCmp('delete',componentIndex)"
                              style="text-align: center">删除
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog
        :append-to-body="true"
        :visible.sync="settingVisible"
        title="设置"
        width="30%">
      <el-switch
          style="display: block;margin-bottom: 10px"
          v-model="horizontal"
          active-text="水平"
          inactive-text="垂直">
      </el-switch>
      <el-row>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">字体大小</span>
          <el-input-number size="mini" v-model="exampleFontSize" :min="12" :max="30" controls-position="right" style="width: 80%"></el-input-number>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">颜色</span>
          <el-color-picker size="mini" v-model="exampleFontColor" show-alpha></el-color-picker>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">预览</span>
          <span :style="`${'font-size: '+exampleFontSize +'px;color: '+exampleFontColor}`">信号名</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-input v-model="settingMin" style="width: 80%">
            <template slot="prepend">最小值</template>
          </el-input>
        </el-col>
        <el-col :span="12">
          <el-input v-model="settingMax" style="width: 80%">
            <template slot="prepend">最大值</template>
          </el-input>
        </el-col>
      </el-row>
      <span class="dialog-footer" slot="footer">
        <el-button @click="settingVisible = false">取 消</el-button>
        <el-button @click="settingVisible = false,setRange(),saveSliderConfig()" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import { PROJECT_NODE_TYPE } from '@/common/enums';
import projectDetailAPI from '@/api/projectDetail';

export default {
  name: 'Slider',
  props: {
    componentIndex: {
      type: Number,
    },
    itemData: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      num: 3,
      min: 0,
      max: 10,
      settingVisible: false,
      settingMin: 0,
      settingMax: 10,
      horizontal: true,
      edit: false,
      name: '信号名',
      fontColor: '#303133',
      exampleFontColor: '#303133',
      fontSize: 15,
      exampleFontSize: 15,
      uDataSources: {
        text: '信号名',
        key: '',
        value: 0,
      },
    };
  },
  mounted() {
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    ...mapMutations('Engineering', ['addSubmitCmp', 'setAnchorKeyWord', 'setAnchorPointId', 'selectCpt']),
    handleCmp(command, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({ index });
          break;
        default:
          break;
      }
    },
    allowSignalMeasureDrop(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_SIGNAL
        || this.dragTreeNodeType === PROJECT_NODE_TYPE.A2L_CHARACTER) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    dragToSubmitCmp(event, componentIndex) {
      // if (this.getCurCmpStatus) {
      //   this.$message({
      //     message: '当前面板正在运行，请先进行关闭',
      //   });
      //   return;
      // }
      console.log('hah');
      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      const { id, dtype, text } = dragNode;
      this.addSubmitCmp({
        id, dtype, text, componentIndex,
      });
    },
    dbClick(event, key) {
      event.stopPropagation();
      const arr = key.split('.');
      const str = arr.join('');
      const arr2 = str.split(':');
      const str2 = arr2.join('');
      this.setAnchorKeyWord(key.substring(key.lastIndexOf('.') + 1)); // 信号名
      setTimeout(() => {
        this.setAnchorKeyWord('');
        this.setAnchorPointId('');
        setTimeout(() => {
          this.setAnchorPointId(str2);
        }, 50);
      }, 50);
    },
    setRange() {
      const max = parseInt(this.settingMax, 10);
      const min = parseInt(this.settingMin, 10);
      this.max = max;
      this.min = min;
    },
    editSignalName() {
      if (this.uDataSources.key !== '') {
        this.edit = true;
      } else {
        this.$message({
          message: '请先绑定信号！',
          type: 'warning',
        });
      }
    },
    async saveControlName() {
      this.edit = false;
      const projectId = this.$store.state.Engineering.projectId;
      const panelId = this.$store.state.Engineering.panelId;
      const componentId = this.itemData.cid;
      const signalKey = this.uDataSources.key;
      const name = this.uDataSources.text;
      console.log({ projectId, panelId, componentId, signalKey, name });
      await projectDetailAPI.saveCptName(projectId, panelId, componentId, signalKey, name)
        .catch((err) => {
          this.$message.error('信号名保存失败！');
        });
    },
    async saveSliderConfig() {
      this.fontSize = this.exampleFontSize;
      this.fontColor = this.exampleFontColor;
      const projectId = this.$store.state.Engineering.projectId;
      const panelId = this.$store.state.Engineering.panelId;
      const componentStyleParams = [];
      const componentStyleParam = {
        componentId: this.itemData.cid,
        wordSize: this.fontSize,
        wordColor: this.fontColor,
        componentSize: '',
        step: 1,
      };
      componentStyleParams.push(componentStyleParam);
      console.log({ projectId, panelId, componentStyleParams });
      await projectDetailAPI.saveCptStyle(projectId, panelId, componentStyleParams)
        .catch((err) => {
          this.$message.error('保存失败！');
        });
    },
    dbClickSetting() {
      this.settingVisible = true;
    },
    select() {
      const id = this.itemData.cid;
      this.selectCpt(id);
    },
    clickSelect(event) {
      if (event.ctrlKey) {
        this.select();
      }
    },
  },
  computed: {
    ...mapGetters('Engineering', ['getCurCmpStatus']),
    ...mapState('Engineering', ['dragTreeNodeType']),
    styleSetting() {
      return this.itemData.styleSetting || [];
    },
    dataSou() {
      return this.itemData.dataSources || [];
    },
    selcted() {
      const id = this.itemData.cid;
      if (this.$store.state.Engineering.selectedCpts.indexOf(id) > -1) {
        return true;
      }
      return false;
    },
    backgroundColor() {
      if (this.selcted) {
        return 'rgba(127,204,232,0.21)';
      }
      return '';
    },
    sliderHeight() {
      return `${(this.itemData.h * 5) - 55}px`;
    },
  },
  watch: {
    // 由0改为setting.length-1，待优化
    styleSetting: {
      handler(setting) {
        // console.log(setting)
        const self = this;
        if (setting.length > 0) {
          self.fontSize = setting[setting.length - 1].fontSize;
          self.fontColor = setting[setting.length - 1].fontColor;
        }
      },
      deep: true,
      immediate: true,
    },
    dataSou: {
      handler(newDataSou) {
        const self = this;
        // self.uDataSources = newDataSou.map(item => ({
        //   text: item.text,
        //   key: item.key,
        //   value: 0,
        // }));
        if (newDataSou.length > 0) {
          self.uDataSources.text = newDataSou[0].text;
          self.uDataSources.key = newDataSou[0].key;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
  .el-input__icon {
    line-height: 25px;
    opacity:0;
  }
  .cmp-handle {
    position: absolute;
    top: 0;
    right: 0;
  }
  .cmp-handle-vertical {
    position: absolute;
    top: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/Slider.vue